import { render, staticRenderFns } from "./needPicList.vue?vue&type=template&id=927c020a&scoped=true&"
import script from "./needPicList.vue?vue&type=script&lang=js&"
export * from "./needPicList.vue?vue&type=script&lang=js&"
import style0 from "./needPicList.vue?vue&type=style&index=0&id=927c020a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927c020a",
  null
  
)

export default component.exports